import React from 'react';
import { LocalServicePage } from '../../components/LocalServicePage';

export const LocksmithStratford = () => {
  return (
    <LocalServicePage
      areaName="Stratford"
      areaType="City"
      slug="locksmith-stratford"
      heroTitle="Door, Window & Lock Services in Stratford"
      heroSubtitle="Royal Security provides specialist door and window repairs across Stratford's diverse housing—from Victorian conversions to Olympic Park developments. We work with residents, landlords, and property managers throughout the area."
      introContent={
        <>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Stratford has transformed dramatically, particularly since the 2012 Olympics. The area now combines established residential neighbourhoods with extensive new development—meaning a huge variety of door and window systems, from traditional to cutting-edge contemporary.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            A significant proportion of Stratford's housing is flatted, whether Victorian conversions, post-war blocks, or the many new-build apartment schemes. We've developed particular expertise in flat entrance doors, communal systems, and the aluminium windows and balcony doors common in modern developments.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            The rental market in Stratford is substantial, and we work regularly with landlords, letting agents, and property managers who need reliable, efficient service. Quick turnaround for tenant issues, honest assessments, and competitive pricing for portfolio work.
          </p>
        </>
      }
      servicesEmphasis={[
        {
          title: "Flat Entrance Door Repairs",
          description: "Stratford's many flats require specialist attention for entrance doors. We work on fire door hardware, flat door locks and mechanisms, letter boxes, and viewers—understanding the specific requirements of shared buildings."
        },
        {
          title: "Aluminium Window & Door Systems",
          description: "Modern Stratford developments feature extensive aluminium systems—windows, balcony doors, sliding systems, and bi-folds. We repair mechanisms, replace hardware, and maintain these contemporary installations."
        },
        {
          title: "Balcony Door Repairs",
          description: "Balcony doors in apartments require secure locking and smooth operation. We service multipoint locks, adjust alignment, replace handles, and ensure these doors function safely and easily."
        },
        {
          title: "Tilt & Turn Windows",
          description: "Common in Stratford flats for ventilation and fire safety, tilt and turn windows have specific mechanisms we're expert in repairing. Restrictors, turn mechanisms, handles, and locking points."
        },
        {
          title: "Letting Agent Services",
          description: "We provide prompt, reliable service for Stratford's letting agents—repairs between tenancies, inventory preparation, urgent tenant issues, and ongoing maintenance. Clear communication and fair invoicing."
        },
        {
          title: "Multipoint Lock Systems",
          description: "Whether on a flat entrance door or main building entrance, multipoint locks need specialist attention when they fail. We diagnose and repair these systems to ensure security."
        }
      ]}
      localContextTitle="Arranging Repairs in Stratford Flats & Managed Blocks"
      localContext={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Who is responsible:</strong> In many blocks, the flat entrance door, communal doors, and external windows may be the freeholder's or managing agent's responsibility rather than the resident's. Check your lease or ask your building manager before booking, so the repair is approved and billed to the right party.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Access and parking:</strong> Let us know about concierge sign-in, loading bays, parking restrictions, and lift access when you book. This avoids delays on the day and helps us bring the right parts up in one trip.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            <strong>Balcony and sliding doors:</strong> Sliding doors that become heavy or jump their track may need the track cleaning or the rollers adjusting or replacing, though the track or frame can also be at fault. Photos of the bottom track and the handle side of the door help us identify the system in advance.
          </p>
        </>
      }
      commonProblems={[
        {
          title: "Flat door not closing on latch",
          description: "Striker alignment or latch mechanism issues. We adjust to ensure secure, reliable closing."
        },
        {
          title: "Balcony door sticking or hard to lock",
          description: "Alignment and mechanism issues common in high-rise conditions. We diagnose and repair."
        },
        {
          title: "Tilt & turn window stuck in position",
          description: "Mechanism failure specific to these windows. We repair or replace the hardware."
        },
        {
          title: "Communal door not closing properly",
          description: "Security concern for whole building. We work with managing agents to resolve."
        },
        {
          title: "Aluminium window handle broken",
          description: "Requires specific aluminium hardware. We source and fit appropriate replacements."
        },
        {
          title: "Fire door closer not functioning",
          description: "Important for building safety. We repair or replace door closer mechanisms."
        }
      ]}
      whyChooseUs={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Our experience with Stratford's diverse housing stock means we're prepared for whatever system we encounter. From Victorian sash repairs to contemporary aluminium bi-folds, we have the expertise and parts to help.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            For landlords and agents, we understand the pressures of managing rental properties. Quick response, honest assessments, and competitive pricing make us a reliable partner for your Stratford portfolio.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            We're accessible from Stratford and can respond quickly when needed. For ongoing work, we offer maintenance arrangements that help prevent problems before they inconvenience tenants or become urgent.
          </p>
        </>
      }
      ctaText="Need Door or Window Services in Stratford?"
    />
  );
};
